<ac-form *ngIf="dialogConfig.ready"
         [formModel]="group"
         [formSchema]="schema"
         [isEdit]="isEdit"
         formModelName="group">

    <div id="group-details-dialog-content">
        <div class="flexRowParentEqualChildren">
            <ac-input-container label="Group Name">
                <ac-textfield [(acModel)]="group.name"
                              [attr.alternativeName]="'group.name'"
                              maxLength="30" textFieldId="group-name">
                </ac-textfield>
            </ac-input-container>

            <ac-input-container label="Description">
                <ac-textarea [(acModel)]="group.description"
                             [attr.alternativeName]="'group.description'"
                             textAreaId="group-description">
                </ac-textarea>
            </ac-input-container>
        </div>

        <network-tenant-region-selection [model]="group"
                                         [additionalSettings]="additionalSettings"
                                         (acTenantChanged)="group.tenantId = $event; treeViewPanelEl?.defaultAttachments()"
                                         tenantAlternativeName="group.tenantId"
                                         [ngDisabledTenant]="isEdit"
                                         [showRegion]="false">
        </network-tenant-region-selection>

        <ac-input-container label="AD Group" *ngIf="additionalSettings.type === 'ENDPOINT'">
            <ac-textfield [(acModel)]="group.ldapGroupName"
                          [attr.alternativeName]="'group.ldapGroupName'"
                          maxLength="30" textFieldId="group-ldapGroupName">
            </ac-textfield>
        </ac-input-container>

        <tree-view-panel [model]="group" *ngIf="additionalSettings.type === 'TOPOLOGY'" #treeViewPanel
                         [additionalSettings]="additionalSettings"
                         type="topology">
        </tree-view-panel>
    </div>
</ac-form>
